import { TOURNAMENT } from "@/data/tournament";
import { Trophy, Shield, Whistle, CalendarDays, MapPin, Users, Wallet, Award } from "lucide-react";

const TROPHY_IMG =
  "https://images.unsplash.com/photo-1637203723757-a9b26181e1ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxjaGFtcGlvbnNoaXAlMjB0cm9waHklMjBnb2xkJTIwZGFya3xlbnwwfHx8fDE3ODA4NDIyNDl8MA&ixlib=rb-4.1.0&q=85";

// Note: lucide doesn't have Whistle named differently—use Award/Shield combos.

const InfoCards = () => {
  return (
    <section
      id="formato"
      data-testid="info-cards-section"
      className="relative bg-[#050505] py-24 sm:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-16">
          <div>
            <div className="flex items-center gap-4 mb-4">
              <span className="text-xs tracking-[0.3em] uppercase text-[#EAB308]">/ 02 · El Formato</span>
            </div>
            <h2 className="font-display text-5xl sm:text-6xl uppercase tracking-tight leading-none">
              Datos de la
              <br />
              <span className="text-[#EAB308]">competición</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-md font-body">
            Todo lo que necesitas saber antes de inscribir a tu equipo. Sin
            sorpresas. Sin letra pequeña.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-6 gap-px bg-white/10">
          {/* Premio - big card with image */}
          <div
            data-testid="info-card-prize"
            className="md:col-span-3 md:row-span-2 relative bg-[#0a0a0a] p-8 sm:p-10 min-h-[320px] overflow-hidden group"
          >
            <img
              src={TROPHY_IMG}
              alt="Trofeo"
              className="absolute right-[-30%] top-[-20%] w-[90%] opacity-20 group-hover:opacity-30 transition-opacity"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-[#0a0a0a] via-[#0a0a0a]/80 to-transparent" />
            <div className="relative z-10 h-full flex flex-col justify-between">
              <div>
                <div className="flex items-center gap-2 text-[#EAB308]">
                  <Trophy className="w-4 h-4" strokeWidth={1.5} />
                  <span className="text-[10px] tracking-[0.3em] uppercase">
                    Premio Campeón
                  </span>
                </div>
              </div>
              <div>
                <div className="font-display text-7xl sm:text-8xl text-[#EAB308] gold-text-glow leading-none">
                  1.000€
                </div>
                <div className="text-white/60 mt-3 text-sm">
                  Premio en metálico para el equipo ganador de la final.
                </div>
              </div>
            </div>
          </div>

          {/* Format */}
          <Card
            label="Formato"
            value="Fútbol 7"
            sub="Liga + Eliminatoria"
            icon={<Users className="w-4 h-4" strokeWidth={1.5} />}
          />

          {/* Teams */}
          <Card
            label="Equipos"
            value="16"
            sub="8 – 12 jugadores"
            icon={<Shield className="w-4 h-4" strokeWidth={1.5} />}
          />

          {/* Dates */}
          <Card
            label="Fecha"
            value="25 OCT"
            sub="Una sola jornada"
            icon={<CalendarDays className="w-4 h-4" strokeWidth={1.5} />}
          />

          {/* Venue */}
          <Card
            label="Sede"
            value="Totem Sports"
            sub="Tordera · 2 campos F11 · 4 partidos a la vez"
            icon={<MapPin className="w-4 h-4" strokeWidth={1.5} />}
          />

          {/* Price */}
          <Card
            label="Inscripción"
            value="150€"
            sub="Apertura 1 de agosto"
            icon={<Wallet className="w-4 h-4" strokeWidth={1.5} />}
          />

          {/* Referee */}
          <Card
            label="Arbitraje"
            value="Incluido"
            sub="Árbitros en todos los partidos"
            icon={<Award className="w-4 h-4" strokeWidth={1.5} />}
          />
        </div>
      </div>
    </section>
  );
};

const Card = ({ label, value, sub, icon }) => (
  <div
    className="md:col-span-3 bg-[#0a0a0a] p-6 sm:p-8 group hover:bg-[#111] transition-colors relative overflow-hidden"
    data-testid={`info-card-${label.toLowerCase()}`}
  >
    <div className="flex items-center gap-2 text-white/50 group-hover:text-[#EAB308] transition-colors">
      {icon}
      <span className="text-[10px] tracking-[0.3em] uppercase">{label}</span>
    </div>
    <div className="font-display text-4xl sm:text-5xl text-white mt-4 leading-none">
      {value}
    </div>
    <div className="text-white/50 text-sm mt-2 font-body">{sub}</div>
    <div className="absolute bottom-0 left-0 h-px w-0 bg-[#EAB308] group-hover:w-full transition-all duration-500" />
  </div>
);

export default InfoCards;
